// extracted by mini-css-extract-plugin
module.exports = {"s1jz41jx":"s1jz41jx","t7a66i8":"t7a66i8"};